export default __webpack_public_path__ + "static/media/canada.ab02b44c.png";